import { Component, OnInit, Input, Output } from '@angular/core';
import { CallAPIService } from '../../../services/call-api.service';
import { latLng, tileLayer, marker, icon } from 'leaflet';
import { BehaviorSubject } from 'rxjs';
import { PostOfficeInfo } from '../../../interfaces/post-office-info.interface';
import { WhatToClear } from '../../../interfaces/what-to-clear.interface';
import * as L from 'leaflet';



@Component({
  selector: 'response-index-loader',
  templateUrl: './response-index-loader.component.html',
  styleUrls: ['./response-index-loader.component.sass']
})
export class ResponseIndexLoaderComponent implements OnInit {

  @Input('clear') clear: BehaviorSubject<WhatToClear>;
  @Input('responseSubject') responseSubject: BehaviorSubject<any>;

  public response;
  public schedule;
  public isResponseError: boolean = false;
  public isShowMap: boolean = false;
  private map: L.Map;

  public officeMarker = //marker( undefined, undefined );
    marker([0, 0], {
      icon: icon({
        iconSize: [0, 0],
        iconAnchor: [25, 50],
        iconUrl: './assets/pinYellow.png',
      })
    });
  public layers = [
    /*tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors'
    }),*/
    tileLayer(
      //'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      'https://tms{s}.visicom.ua/2.0.0/world,ua/base/{z}/{x}/{y}.png', {
      attribution: "Дані карт © 2022 АТ «<a href='https://api.visicom.ua/'>Візіком</a>»", //'&copy; OpenStreetMap contributors',
      subdomains: "123",
      maxZoom: 19,
      tms: true
    }),
    this.officeMarker
  ];
  public center = latLng([46.879966, -121.726909]);
  public options = {
    layers: this.layers, // this.layers
    zoom: 15,
    center: this.center // this.center
  };
  public hiddenMarkerOptions = JSON.parse(JSON.stringify(this.options));

  constructor(
    private API: CallAPIService
  ) {

    this.API.getObservablePostOfficeInfo().subscribe(indexReponse => {
      this.isShowMap = false;
      this.response = null; // ?
      if (indexReponse != undefined && indexReponse instanceof Array && Object.keys(indexReponse[0]).length) {

        this.buildNewSetupForMap(indexReponse)

      } else {

        this.isResponseError = true;
      }

    })


  }


  ngOnInit() {

    this.clear.asObservable().subscribe((cl: WhatToClear) => {
      if (cl) {

        if (cl.toClearResponse)
          this.response = null;
        if (cl.toClearSchedule)
          this.schedule = null;

      }
    });

  }


  public buildNewSetupForMap(indexReponse) {
    let mainOffice;

    if (indexReponse && indexReponse instanceof Array && indexReponse.length > 1 && !indexReponse[0].error) {
      let centralOffice;
      let cityOffice;

      centralOffice = indexReponse.find((currentOffice: PostOfficeInfo) => {
        return currentOffice.TYPE_ACRONYM.trim() == "ЦВПЗ"
      })

      cityOffice = indexReponse.find((currentOffice: PostOfficeInfo) => {
        let type = currentOffice.TYPE_ACRONYM.toLocaleLowerCase().trim();
        return (type == 'мвпз' || type == 'свпз')
      })

      if (centralOffice && cityOffice) {
        mainOffice = centralOffice;      // priority for 
      } else {
        if (centralOffice) {
          mainOffice = centralOffice;
        }
        if (cityOffice) {
          mainOffice = cityOffice;
        }
      }
    }

    if (mainOffice) {
      this.response = [mainOffice];
    } else {
      this.response = indexReponse;
    }

    if (this.responseSubject)
      this.responseSubject.next(this.response); // trigger scroll to feature


    if (this.API.isEmptyObject(indexReponse[0].LATTITUDE) && this.API.isEmptyObject(indexReponse[0].LONGITUDE)) {
      indexReponse[0].LATTITUDE = null;
      indexReponse[0].LONGITUDE = null;
      this.isShowMap = false;
    } else {
      this.isShowMap = true;
    }



    if (indexReponse && indexReponse[0] && indexReponse[0].LATTITUDE && indexReponse[0].LONGITUDE) { // && ! indexReponse[0].error

      this.schedule = indexReponse[0].scadule;

      let coordinates: [number, number] = [indexReponse[0].LATTITUDE, indexReponse[0].LONGITUDE];

      //L.latLng( indexReponse[0].LATTITUDE , indexReponse[0].LONGITUDE );

      let newMarker = marker(coordinates, {
        icon: icon({
          iconSize: [50, 50],
          iconAnchor: [25, 50],
          iconUrl: './assets/pinYellow.png',
        })
      });

      let newLayers = [
        /*tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; OpenStreetMap contributors'
        }),*/
        tileLayer(
          //'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
          'https://tms{s}.visicom.ua/2.0.0/world,ua/base/{z}/{x}/{y}.png', {
          attribution: "Дані карт © 2022 АТ «<a href='https://api.visicom.ua/'>Візіком</a>»", //'&copy; OpenStreetMap contributors',
          subdomains: "123",
          maxZoom: 19,
          tms: true
        }),
        newMarker
      ]

      let newOptions = Object.assign({}, this.options);
      newOptions.center = latLng(coordinates)
      newOptions.layers = newLayers;

      this.options = newOptions;
      this.isResponseError = false;

    }

  }


  onMapReady(readyMap: L.Map) {
    this.map = readyMap;

  }

  triggerMap() {
    if (this.map) {
      this.map.invalidateSize(true)

    }
  }

  clearResponseData() {
    this.response = null;
    this.schedule = null;

  }

  isDistrictCenter(districtName: string): boolean {
    if (districtName == undefined)
      return false
    return districtName.toLocaleLowerCase().includes('місто')
  }

  isContainsPostOfficeType(name: string): boolean {
    if (name == undefined)
      return false
    name = name.toLocaleLowerCase().trim();
    let result = name.includes('пвпз') ||
      name.includes('мвпз') ||
      name.includes('свпз') ||
      name.includes('впз') || false;
    return result
  }

  isMVPZ(acronym: string): boolean {
    if (!acronym) return false
    return acronym.toLocaleLowerCase().trim() == 'мвпз'.trim()
  }

  isSVPZ(acronym: string): boolean {
    if (!acronym) return false
    return acronym.toLocaleLowerCase().trim() == 'свпз'.trim()
  }

  isPVPZ(acronym: string): boolean {
    if (!acronym) return false
    return acronym.toLocaleLowerCase().trim() == 'пвпз'.trim()
  }

  isString(a) {
    return typeof a == 'string'
  }
}
